import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门精选", href: "#hot" },
  { label: "吃瓜分类", href: "#categories" },
  { label: "全部视频", href: "#videos" },
  { label: "热点专题", href: "#feature" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <a href="#home" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-video-line text-lg"></i>
            </span>
            <span
              className={`font-heading text-xl md:text-2xl ${
                solid ? "text-primary-600" : "text-background-50"
              }`}
            >
              吃瓜视频
            </span>
          </a>

          <ul className="hidden md:flex items-center gap-8">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className={`text-sm whitespace-nowrap transition-colors hover:text-primary-500 ${
                    solid ? "text-foreground-800" : "text-background-50/90"
                  }`}
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#videos"
                className={`inline-flex items-center gap-1.5 rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  solid
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : "bg-background-50 text-primary-600 hover:bg-primary-100"
                }`}
              >
                <i className="ri-play-circle-line"></i>
                立即开看
              </a>
            </li>
          </ul>

          <button
            type="button"
            aria-label="打开菜单"
            className="flex md:hidden h-9 w-9 items-center justify-center rounded-md"
            onClick={() => setOpen(!open)}
          >
            <i
              className={`${solid ? "text-foreground-900" : "text-background-50"} text-2xl ${
                open ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4">
            <ul className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li className="mt-2">
                <a
                  href="#videos"
                  onClick={() => setOpen(false)}
                  className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600"
                >
                  <i className="ri-play-circle-line"></i>
                  立即开看
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}